<template>
  <div>
    <div class="card-body">
      <table class="table table-sm table-bordered">
        <thead class="bg-custom">
          <tr>
            <th>Risk Type</th>
            <th>Risk Details/Conditions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in riskData" :key="index">
            <td>{{ row.BPCRP_RISKVARIABLE }}</td>
            <td>{{ row.BPCRP_RISKDESC }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        riskData: []
      };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/pageLoadHLRC?ID=" + this.clientid)
          .then(function (res) {
            vm.riskData = res.data.riskData;
          })
          .catch((error) => {
            console.log(error);
            endReq();
          });
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/ims/HighLowRiskCustomer.vue